import orderBy from "lodash/orderBy";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import moment from "moment";
import config from "@/js/const";
import { arrayCount, hasProperty } from "@/js/utils";

export class DisasterTranslator {
  static PREF_CODE = "46";
  static toPayload(editedItem, isUpdate, isDeleteFlg) {
    let emerg_cls = "";
    if (editedItem.emerg_cls) {
      if (editedItem.emerg_cls.emergencyClass) {
        emerg_cls = editedItem.emerg_cls.emergencyClass;
      } else {
        emerg_cls = editedItem.emerg_cls;
      }
    } else {
      emerg_cls = EmergencyClass.NL;
    }
    const emergencyClassObj = EmergencyClass.factory(emerg_cls);
    let emerg_reg_date = null;
    if (emergencyClassObj.isAl()) {
      emerg_reg_date = editedItem.each_emerg_reg_date_al;
    } else if (emergencyClassObj.isSe()) {
      emerg_reg_date = editedItem.each_emerg_reg_date_se;
    } else if (emergencyClassObj.isGe()) {
      emerg_reg_date = editedItem.each_emerg_reg_date_ge;
    } else if (emergencyClassObj.isFn()) {
      emerg_reg_date = editedItem.each_emerg_reg_date_fn;
    } else if (emergencyClassObj.isNl()) {
      emerg_reg_date = moment().format(
        config.DATETIME_FORMAT_YYYYMMDDHHMMSS_WITH_SLASH_COLON
      );
    }
    emerg_reg_date = DisasterTranslator.formatDatetime(emerg_reg_date);
    let disaster_accdate = DisasterTranslator.formatDatetime(
      editedItem.disaster_accdate
    );
    if (isUpdate) {
      if (isDeleteFlg) {
        return {
          disaster_no: editedItem.disaster_no,
          disaster_name: editedItem.disaster_name,
          emerg_cls,
          pref_code: DisasterTranslator.PREF_CODE,
          disaster_cls: editedItem.disaster_cls,
          disaster_accdate,
          emerg_reg_date,
          delete_flg: "1",
          hash: editedItem.hash
        };
      } else {
        return {
          disaster_no: editedItem.disaster_no,
          disaster_name: editedItem.disaster_name,
          emerg_cls,
          pref_code: DisasterTranslator.PREF_CODE,
          disaster_cls: editedItem.disaster_cls,
          disaster_accdate,
          emerg_reg_date,
          hash: editedItem.hash
        };
      }
    }
    return {
      disaster_name: editedItem.disaster_name,
      emerg_cls,
      pref_code: DisasterTranslator.PREF_CODE,
      disaster_cls: editedItem.disaster_cls,
      disaster_accdate,
      emerg_reg_date
    };
  }
  static formatDatetime(datetime) {
    const before = config.DATETIME_FORMAT_YYYYMMDDHHMMSS_WITH_SLASH_COLON;
    const after = config.DATETIME_FORMAT_YYYYMMDDHHMMSS00_WITH_HYPHEN_COLON;
    if (!datetime) {
      return "";
    }
    if (datetime.length === 19) {
      return moment(datetime, before).format(after);
    } else {
      return moment(datetime).format(after);
    }
  }
  /**
   * 災害名称情報を災害番号でソート
   * @param list
   * @param sortDesc
   * @returns {unknown[]|*}
   */
  static sortByDisasterNo(list, sortDesc = false) {
    if (arrayCount(list) < 1) {
      return list;
    }
    const key = "disaster_no";
    return orderBy(list, key, DisasterTranslator.getSortType(sortDesc));
  }
  /**
   * 緊急事態区分履歴情報を緊急事態区分連番でソート
   * @param list
   * @param sortDesc
   * @returns {unknown[]|*}
   */
  static sortHistoriesByEmergClsNum(list, sortDesc = false) {
    if (arrayCount(list) < 1) {
      return list;
    }
    const key = "each_emerg_cls_num";
    list.forEach(data => {
      if (hasProperty(data, key)) {
        data[key] = Number(data[key]);
      }
    });
    return orderBy(list, key, DisasterTranslator.getSortType(sortDesc));
  }
  /**
   * 昇順か降順かを配列で返却
   * @param sortDesc
   * @returns {string[]}
   */
  static getSortType(sortDesc) {
    if (sortDesc === true) {
      return ["desc"];
    }
    return ["asc"];
  }
}
